export default __webpack_public_path__ + "static/media/parallel-arrows.03b54ff0.svg";